import { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Loader from "../components/loader";
import { fetchPartner } from "../hooks/fetchPartner";

const AppContext = createContext();

export function AppWrapper({ children }) {
  const [partner, setPartner] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  useEffect(() => {
    if (!partner) {
      setLoading(true);
      const getStoreData = async () => {
        const storeData = await fetchPartner();

        if (
          window.location?.href?.includes("/login") ||
          window.location?.href?.includes("/register")
        ) {
          setLoading(false);
        }
        if (storeData?.result) {
          setPartner(storeData?.result);
          setLoading(false);
        }
      };
      getStoreData();
    }
  }, [location]);

  if (loading) {
    return <Loader />;
  }

  return (
    <AppContext.Provider
      value={{
        partner,
        setPartner,
        fetchPartner,
        loading,
        setLoading,
      }}
    >
      {children}
    </AppContext.Provider>
  );
}

export default AppWrapper;

export function useAppContext() {
  return useContext(AppContext);
}
